import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 100px;
    margin-bottom: 35px;
    cursor: pointer;
`;

export const Title = styled.div`
    font-size: 30px;
    font-weight: 900;
`;

export const HighlightedText = styled.div`
    font-size: 24px;
    font-weight: 200;
    line-height: 20px;

    font-style: italic;
    position: relative;

    & > div {
        position: absolute;
        height: 9px;
        width: 105%;
        bottom: -6px;
        left: -5px;
        background-color: #aeff01;
        z-index: -1;
    }
`;

export const PhoneCallWrapper = styled.div`
    border: 1px solid black;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px 6px;
    margin-top: 20px;
`;

export const PhoneCallImage = styled.img`
    margin-right: 3px;
`;
export const PhoneCallText = styled.a`
    font-size: 13px;
    font-weight: 700;
    text-decoration: none;
    color: black;
    &:hover,
    &:active,
    &:focus {
        text-decoration: none;
        color: black;
    }
`;
